import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import AnexoUnicoPanel from "components/anexo/AnexoUnicoPanel";
import { Label } from "components/input/Label";
import Usuario from "model/administracao/cadastro/Usuario";
import CategoriaDocumento from "model/documentos/CategoriaDocumento";
import Documento from "model/documentos/Documento";
import { DocumentoPasta } from "model/documentos/DocumentoPasta";
import { AutoComplete } from "primereact/autocomplete";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useEffect, useState } from "react";
import "react-hook-form";
import { Controller, useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import DocumentoPastaService from "service/documentos/DocumentoPastaService";
import DocumentoService from "service/documentos/DocumentoService";
import { usuarioCompleteMethod, usuarioItemTemplate } from "utils/autocompleteUtils";

const documentoService = new DocumentoService();
const documentoPastaService = new DocumentoPastaService();

type Props = {
    isModal?: boolean;
    onSave?: (model: Documento) => void;
}

export default function DocumentoCadastro(props: Props) {

    const [queryParameters] = useSearchParams();

    const { control, clearErrors, setError, setFocus, register, formState: { errors } } = useForm();

    const [documento, setDocumento] = useState<Documento>(new Documento());
    const [titulo, setTitulo] = useState<string>('Documento');
    const [pastas, setPastas] = useState<DocumentoPasta[]>([]);

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    const [categorias, setCategorias] = useState<CategoriaDocumento[]>([]);

    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [usuariosFiltrados, setUsuariosFiltrados] = useState<Usuario[]>([]);
    const [anexoCadastro, setAnexoCadastro] = useState<any>();

    useEffect(() => {
        documentoService.categorias().then((response) => {
            setCategorias(response);
        }).catch((error) => {
            console.error("Erro ao buscar categorias:", error);
            msgErro("Erro", "Erro ao buscar categorias: " + error.message)
        })
        documentoService.usuarios().then((response) => {
            setUsuarios(response);
        }).catch((error) => {
            console.error("Erro ao buscar usuários:", error);
            msgErro("Erro", "Erro ao buscar usuários: " + error.message)
        })
        documentoPastaService.buscarTodas().then((response) => {
            response.unshift(new DocumentoPasta(0, '(Raiz)', null))
            setPastas(response);
        }).catch((error) => {
            console.error("Erro ao buscar pastas:", error);
            msgErro("Erro", "Erro ao buscar pastas: " + error.message)
        });
    }, [])


    function validar() {
        if (!documento.codigoInterno) {
            setError("codigoInterno", { type: "manual", message: "Código é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!documento.nome) {
            setError("nome", { type: "manual", message: "Nome é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (documento.versaoInicial !== 0 && !documento.versaoInicial) {
            setError("versaoInicial", { type: "manual", message: "Versão inicial é Obrigatória" }, { shouldFocus: true })
            return false;
        }
        if (!documento.categoria || !documento.categoria.id) {
            setError("categoria", { type: "manual", message: "Categoria é Obrigatória" }, { shouldFocus: true })
            return false;
        }
        if (documento.confirmacaoLeitura && !documento.diasConfirmacaoLeitura) {
            setError("diasConfirmacaoLeitura", { type: "manual", message: "Dias para confirmação de leitura é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (documento.controlaPrazo && !documento.mesesPrazo) {
            setError("mesesPrazo", { type: "manual", message: "Meses para controle de prazo é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (documento.alertaVencimento && !documento.diasAlertaVencimento) {
            setError("diasAlertaVencimento", { type: "manual", message: "Dias para alerta de vencimento é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!documento.usuarioResponsavel || !documento.usuarioResponsavel.id) {
            setError("usuarioResponsavel", { type: "manual", message: "Usuário responsável é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (documento.tipoGestao === "GED" && !anexoCadastro) {
            setError("arquivoGed", { type: "manual", message: "O arquivo é obrigatório para documentos GED" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    function getModel(): Documento | FormData {
        if (documento.id || (documento.tipoGestao !== "GED" && !anexoCadastro)) {
            return documento;
        }
        const formData = new FormData();
        formData.append("documento", new Blob([JSON.stringify(documento)], { type: "application/json" }));
        formData.append("arquivo", anexoCadastro.file as File);
        return formData;
    }

    const codigoKeyDown = (e: any) => {
        console.log(e.key)
        if (e.key === 'Enter') {
            console.log(documento.codigoInterno.substring(documento.categoria.prefixo.length))
            if (documento?.categoria.prefixo && !documento.codigoInterno.substring(documento.categoria.prefixo.length)) {
                documentoService.proximoCodigo(documento.categoria.id).then((data) => {
                    setDocumento({ ...documento, codigoInterno: String(data) });
                    setFocus("nome");
                    clearErrors("codigo");
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }

    return (

        <BaseCadastro model={documento} service={documentoService} isModal={props.isModal} setModel={(value: Documento) => setDocumento(value)} onSave={props.onSave} getModel={getModel}
            validar={() => validar()} urlService="/documento" pathCadastro="/documento" tituloPagina={titulo}>
            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}
            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Tipo</Label>
                <div className="col-sm-12">
                    <Dropdown value={documento.tipoGestao}
                        options={[
                            { value: "CONTROLADO", label: "Controlado" },
                            { value: "GED", label: "GED" }
                        ]}
                        optionValue="value" optionLabel="label"
                        disabled={documento.id !== 0}
                        onChange={(e) => setDocumento({ ...documento, tipoGestao: e.value })}
                        style={{ width: '100%' }} />
                </div>
            </div>
            {documento.id === 0 ? <div className="row">
                <Label className="col col-sm-12" obrigatorio={documento.tipoGestao === "GED"}>Arquivo</Label>
                <div className="col-sm-12 d-flex align-items-center justify-content-center">
                    <AnexoUnicoPanel
                        novoAnexo={anexoCadastro}
                        onChangeNovoAnexo={(anexo) => {
                            setAnexoCadastro(anexo);
                            clearErrors("arquivoGed");
                        }}
                        arquivo={null}
                        onChange={() => { }}
                        editable
                        allowDocumentoOnline={false}
                    />
                </div>
                {errors.arquivoGed && errors.arquivoGed.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.arquivoGed?.message as string}</span> : null}
            </div> : null}
            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Categoria</Label>
                <div className="col-sm-12">
                    <Controller name="categoria" control={control} render={({ field }) => (
                        <Dropdown
                            focusInputRef={field.ref}
                            options={categorias}
                            className={errors.categoria ? "p-invalid" : ""}
                            optionLabel='nome'
                            value={documento.categoria}
                            onChange={(e) => {
                                setDocumento({ ...documento, categoria: e.target.value, codigoInterno: e.target.value.prefixo + documento.codigoInterno.substring(documento?.categoria?.prefixo?.length || 0) })
                                clearErrors("categoria")
                            }}
                            style={{ width: '100%' }}
                        />
                    )} />
                </div>
                {errors.categoria && errors.categoria.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.categoria?.message as string}</span> : null}
            </div>
            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Código</Label>
                <div className="col-sm-12">
                    <div style={{ display: 'flex' }}>
                        <div style={{ border: "1px solid #a6a6a6", display: "flex", alignItems: "center", justifyContent: "center", borderBottomLeftRadius: 3, borderTopLeftRadius: 3, width: "100px", backgroundColor: "#fff" }}>
                            <span style={{ color: "#a6a6a6", fontSize: 16 }} >{documento?.categoria?.prefixo || ""}</span>
                        </div>
                        <InputText
                            className={errors.codigoInterno ? "p-invalid" : ""}
                            onKeyDown={codigoKeyDown}
                            required value={documento.codigoInterno.substring(documento?.categoria?.prefixo?.length || 0)}
                            style={{ width: '200px', marginLeft: -1, borderBottomLeftRadius: 0, borderTopLeftRadius: 0 }}
                            {...register("codigoInterno", {
                                onChange: (e) => {
                                    setDocumento({ ...documento, codigoInterno: documento?.categoria?.prefixo + e.target.value })
                                    clearErrors("codigoInterno")
                                }
                            })}
                        />
                    </div>

                </div>
                {errors.codigoInterno && errors.codigoInterno.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.codigoInterno?.message as string}</span> : null}
            </div>
            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText
                        className={errors.nome ? "p-invalid" : ""}
                        required value={documento.nome}
                        style={{ width: '30%' }}
                        {...register("nome", {
                            onChange: (e) => {
                                setDocumento({ ...documento, nome: e.target.value })
                                clearErrors("nome")
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>
            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Versão Inicial</Label>
                <div className="col-sm-12">
                    <Controller name="versaoInicial" control={control} render={({ field }) => (
                        <InputNumber value={documento.versaoInicial}
                            inputRef={field.ref}
                            useGrouping={false}
                            maxFractionDigits={0}
                            minFractionDigits={0}
                            max={9999999999}
                            onChange={(e) => {
                                clearErrors("versaoInicial")
                                setDocumento({ ...documento, versaoInicial: e.value as number })
                            }}
                            style={{ width: '30%' }} />
                    )} />
                </div>
                {errors.versaoInicial && errors.versaoInicial.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.versaoInicial?.message as string}</span> : null}
            </div>
            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Interno/Externo</Label>
                <div className="col-sm-12">
                    <Controller name="internoExterno" control={control} render={({ field }) => (
                        <Dropdown
                            focusInputRef={field.ref}
                            options={[
                                { value: "INTERNO", label: "Interno" },
                                { value: "EXTERNO", label: "Externo" }
                            ]}
                            className={errors.internoExterno ? "p-invalid" : ""}
                            optionValue="value"
                            optionLabel='label'
                            value={documento.internoExterno}
                            onChange={(e) => {
                                setDocumento({ ...documento, internoExterno: e.target.value })
                                clearErrors("internoExterno")
                            }}
                            style={{ width: '100%' }}
                        />
                    )} />
                </div>
                {errors.internoExterno && errors.internoExterno.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.internoExterno?.message as string}</span> : null}
            </div>
            <div style={{ display: 'flex', marginTop: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', columnGap: 8, width: 250 }}>
                    <Checkbox checked={documento.confirmacaoLeitura} onChange={(e) => setDocumento({ ...documento, confirmacaoLeitura: e.checked as boolean })} />
                    <label className="col col-sm-12">Confirmação de leitura</label>
                </div>
                <div >
                    <Label className="col col-sm-12" style={{ fontWeight: 700, color: documento.confirmacaoLeitura ? "#000" : "#777" }} obrigatorio={documento.confirmacaoLeitura}>Dias para confirmação</Label>
                    <div className="col-sm-12">
                        <InputNumber
                            disabled={!documento.confirmacaoLeitura}
                            value={documento.diasConfirmacaoLeitura}
                            onChange={(e) => {
                                clearErrors("diasConfirmacaoLeitura")
                                setDocumento({ ...documento, diasConfirmacaoLeitura: e.value as number })
                            }}
                        />
                    </div>
                    {errors.diasConfirmacaoLeitura && errors.diasConfirmacaoLeitura.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.diasConfirmacaoLeitura?.message as string}</span> : null}
                </div>
            </div>

            <div style={{ display: 'flex', marginTop: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', columnGap: 8, width: 250 }}>
                    <Checkbox checked={documento.controlaPrazo} onChange={(e) => setDocumento({ ...documento, controlaPrazo: e.checked as boolean })} />
                    <label className="col col-sm-12">Controla prazo de validade</label>
                </div>
                <div >
                    <Label className="col col-sm-12" style={{ fontWeight: 700, color: documento.controlaPrazo ? "#000" : "#777" }} obrigatorio={documento.controlaPrazo}>Prazo de validade (meses)</Label>
                    <div className="col-sm-12">
                        <InputNumber
                            disabled={!documento.controlaPrazo}
                            value={documento.mesesPrazo}
                            onChange={(e) => {
                                clearErrors("mesesPrazo")
                                setDocumento({ ...documento, mesesPrazo: e.value as number })
                            }
                            }
                        />
                    </div>
                    {errors.mesesPrazo && errors.mesesPrazo.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.mesesPrazo?.message as string}</span> : null}
                </div>
            </div>

            <div style={{ display: 'flex', marginTop: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', columnGap: 8, width: 250 }}>
                    <Checkbox checked={documento.alertaVencimento} onChange={(e) => setDocumento({ ...documento, alertaVencimento: e.checked as boolean })} />
                    <label className="col col-sm-12">Alerta vencimento</label>
                </div>
                <div >
                    <Label className="col col-sm-12" style={{ fontWeight: 700, color: documento.alertaVencimento ? "#000" : "#777" }} obrigatorio={documento.alertaVencimento}>Dias para alerta de vencimento</Label>
                    <div className="col-sm-12">
                        <InputNumber
                            disabled={!documento.alertaVencimento}
                            value={documento.diasAlertaVencimento}
                            onChange={(e) => {
                                clearErrors("diasAlertaVencimento")
                                setDocumento({ ...documento, diasAlertaVencimento: e.value as number })
                            }
                            }
                        />
                    </div>
                    {errors.diasAlertaVencimento && errors.diasAlertaVencimento.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.diasAlertaVencimento?.message as string}</span> : null}
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Responsável</Label>
                <div className="col-sm-12">

                    <Controller name="usuarioResponsavel" control={control} render={({ field }) => (
                        <AutoComplete
                            inputRef={field.ref}
                            dropdown
                            value={documento.usuarioResponsavel}
                            placeholder="Selecione um Usuário"
                            style={{ width: '100%' }}
                            className={errors.responsavelAprovacao ? "p-invalid" : ""}
                            field="nome"
                            itemTemplate={(item: Usuario) => usuarioItemTemplate(item)}
                            suggestions={usuariosFiltrados}
                            completeMethod={(e) => {
                                let filtered: Usuario[] = usuarioCompleteMethod(usuarios, e.query);
                                setUsuariosFiltrados(filtered);
                            }}
                            onChange={(e) => {
                                let documentoLocal = JSON.parse(JSON.stringify(documento)) as Documento;

                                if (!e.target.value) {
                                    documentoLocal.usuarioResponsavel = null;
                                } else if (typeof e.target.value == "string") {
                                    let usuario = new Usuario();
                                    usuario.nome = e.target.value;
                                    documentoLocal.usuarioResponsavel = usuario;
                                } else {
                                    documentoLocal.usuarioResponsavel = e.target.value;
                                }
                                clearErrors("usuarioResponsavel")
                                setDocumento(documentoLocal);
                            }}
                        />)}
                    />
                </div>
                {errors.usuarioResponsavel && errors.usuarioResponsavel.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.usuarioResponsavel?.message as string}</span> : null}
            </div>
            <div className="row">
                <Label className="col col-sm-12" >Pasta mãe</Label>
                <Dropdown
                    className="col col-sm-12"
                    value={documento.pastaMae}
                    onChange={(e) => setDocumento({ ...documento, pastaMae: e.value })}
                    options={pastas}
                    optionLabel="nome"
                    dataKey="id"
                />
            </div>
            <div className="row">
                <Label className="col col-sm-12">Observação</Label>
                <div className="col-sm-12">
                    <InputTextarea
                        value={documento.observacao}
                        style={{ width: '100%' }}
                        onChange={(e) => setDocumento({ ...documento, observacao: e.target.value })}
                    />
                </div>
            </div>

        </BaseCadastro>
    )
}
